// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiButton-active {
    background-color: white !important;
    color: #42a5f5 !important;
    font-weight: bold !important;
}

.MuiTableCell-head {
    background-color: #42a5f5;
    color: #fff !important;
}

.MuiGrid-item img {
    padding-right: 5px;
}

.FormRowOdd div {
    background-color: #eee;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

.uploadIcon input {
    width: 0 !important;
    padding: 0 !important;
}

.uploadIcon label {
    padding: 0 !important;
}

.uploadIcon fieldset {
    border: none !important;
}

.service-row:hover {
    filter: brightness(95%);
    cursor: pointer;
}
.statusOtkazan {
    background-color: #ff9999;
}
.statusRezervacija {
    background-color: #99c2ff;
}
.statusZakazan {
    background-color: #ffeb99;
}
.statusZavršen {
    background-color: #ccff99;
}

.newline-break {
    white-space: pre-wrap; /* Ensures whitespace is respected */
}

tr .MuiTableCell-root {
    padding: 4px 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/main/js/main.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB,EAAE,oCAAoC;AAC/D;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".MuiButton-active {\r\n    background-color: white !important;\r\n    color: #42a5f5 !important;\r\n    font-weight: bold !important;\r\n}\r\n\r\n.MuiTableCell-head {\r\n    background-color: #42a5f5;\r\n    color: #fff !important;\r\n}\r\n\r\n.MuiGrid-item img {\r\n    padding-right: 5px;\r\n}\r\n\r\n.FormRowOdd div {\r\n    background-color: #eee;\r\n    border-top: 1px solid #ccc;\r\n    border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.uploadIcon input {\r\n    width: 0 !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.uploadIcon label {\r\n    padding: 0 !important;\r\n}\r\n\r\n.uploadIcon fieldset {\r\n    border: none !important;\r\n}\r\n\r\n.service-row:hover {\r\n    filter: brightness(95%);\r\n    cursor: pointer;\r\n}\r\n.statusOtkazan {\r\n    background-color: #ff9999;\r\n}\r\n.statusRezervacija {\r\n    background-color: #99c2ff;\r\n}\r\n.statusZakazan {\r\n    background-color: #ffeb99;\r\n}\r\n.statusZavršen {\r\n    background-color: #ccff99;\r\n}\r\n\r\n.newline-break {\r\n    white-space: pre-wrap; /* Ensures whitespace is respected */\r\n}\r\n\r\ntr .MuiTableCell-root {\r\n    padding: 4px 8px !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
